module.exports = __webpack_public_path__ + "img/icon1.bd6e9402.png";